import React from 'react';

interface CheckCircleIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const CheckCircleIcon: React.FC<CheckCircleIconProps> = ({ 
  width = 14, 
  height = 13, 
  color = '#BABABA' 
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 14 13" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M12.6016 6.49984C12.6016 3.40704 10.0941 0.899577 7.0013 0.899577C3.90851 0.899577 1.40104 3.40704 1.40104 6.49984C1.40104 9.59263 3.90851 12.1001 7.0013 12.1001C10.0941 12.1001 12.6016 9.59263 12.6016 6.49984ZM8.71875 4.88395C8.87496 4.72774 9.12764 4.72774 9.28385 4.88395C9.44006 5.04016 9.44006 5.29285 9.28385 5.44906L6.61719 8.11572C6.46098 8.27193 6.20829 8.27193 6.05208 8.11572L4.71875 6.78239C4.56254 6.62618 4.56254 6.37349 4.71875 6.21728C4.87496 6.06107 5.12764 6.06107 5.28385 6.21728L6.33464 7.26807L8.71875 4.88395ZM13.401 6.49984C13.401 10.0345 10.5359 12.8996 7.0013 12.8996C3.46668 12.8996 0.601562 10.0345 0.601562 6.49984C0.601562 2.96521 3.46668 0.100098 7.0013 0.100098C10.5359 0.100098 13.401 2.96521 13.401 6.49984Z" 
        fill={color}
      />
    </svg>
  );
};

export default CheckCircleIcon;

